import React, { forwardRef } from 'react'
import CircularProgress from '@mui/material/CircularProgress'
import IconButton from '@mui/material/IconButton'

type LoadingIconButtonProps = {
  loading?: boolean
  children: React.ReactNode
} & React.ComponentProps<typeof IconButton>

const LoadingIconButton = forwardRef<HTMLButtonElement, LoadingIconButtonProps>(
  ({ loading = false, children, ...props }, ref) => {
    return (
      <IconButton {...props} ref={ref} disabled={loading}>
        {loading ? <CircularProgress size={24} color="inherit" /> : children}
      </IconButton>
    )
  }
)

LoadingIconButton.displayName = 'LoadingIconButton'

export default LoadingIconButton
